import { GIPIAbstractDTO, GIPIUuid, ObjectUtil } from '@gipisistemas/ng-core';
import { FinancialPostingCategory } from '../posting-category.model';

export class FinancialPostingCategorySelectDTO extends GIPIAbstractDTO {

    /** Descrição */
    description: string;

    /** Código da categoria */
    fullCode: string;

    /** Id do rateio de centro de custo */
    costCenterAssessmentId: GIPIUuid;

    constructor() {
        super();
    }

    public static transformToDTO(postingCategory: FinancialPostingCategory): FinancialPostingCategorySelectDTO {
        const postingCategoryDTO: FinancialPostingCategorySelectDTO = new FinancialPostingCategorySelectDTO();
        postingCategoryDTO.id = postingCategory.id;
        postingCategoryDTO.enabled = postingCategory.enabled;
        postingCategoryDTO.description = postingCategory.description;
        postingCategoryDTO.fullCode = postingCategory.fullCode;
        postingCategoryDTO.costCenterAssessmentId = !ObjectUtil.isNull(postingCategory.costCenterAssessment) ? postingCategory.costCenterAssessment.id : null;
        return postingCategoryDTO;
    }

}
